import React, { Component } from 'react'
import { GoogleMap, withScriptjs, withGoogleMap, Marker } from 'react-google-maps'

function Map() {
    return(
        <GoogleMap
            defaultZoom={10}
            defaultCenter={{ lat: 34.449824, lng: -84.914168}}
        >
            <Marker position={{lat: 34.449824, lng: -84.914168}} />
        </ GoogleMap>
    );
}

const WrappedMap = withScriptjs(withGoogleMap(Map));

class MyGoogleMap extends Component {
    shouldComponentUpdate() {
        return false;
    }
    
    render() {
        return (
            <div id="map" style={{height: '330px', width: '390px'}}>
                <WrappedMap
                    googleMapURL={'https://maps.googleapis.com/maps/api/js?key=AIzaSyDSZxdeDX89yKa2ffnEM0qP986M0XXIZoQ&callback=initMap'}
                    loadingElement={<div style={{ height: '100%'}} />}
                    containerElement={<div style={{ height: '100%'}} />}
                    mapElement={<div style={{ height: '100%'}} />}
                />   
            </div>
        );
    }
}

export default MyGoogleMap
